import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup
} from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { store } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';

export const RedactedCertifiedDialog = ({
  setOpen,
  handleClosePHI,
  setDisablePHI,
  metaData,
  setMetaData,
  setChecked
}: any) => {
  const [certified, setCertified] = useState(false);
  const [disable, setDisable] = useState(true);

  const handleChangeCheck = () => {
    const temp = certified ? false : true;
    setCertified(temp);
    setDisable(false);
  };

  const handleCloseDialog = () => {
    setChecked(false);
    setOpen(false);
    setMetaData({ ...metaData, isf_doc_viewer_red_certified_copy: 'N', isf_doc_viewer_doc_phi_redacted: 'N' });
    handleClosePHI();
    setDisablePHI(false);
  };

  const handleSave = () => {
    setChecked(true);
    setMetaData({
      ...metaData,
      isf_doc_viewer_red_certified_copy: certified == true ? 'Y' : 'N',
      isf_doc_viewer_doc_phi_redacted: 'Y'
    });
    store.dispatch(setSnackbarMessage('Document redaction is certified', 'success'));
    setOpen(false);
    handleClosePHI();
    setDisablePHI(true);
  };

  return (
    <div className="versionControl-modal">
      <React.Fragment>
        <DialogTitle>Redacted Certified Copy</DialogTitle>
        <DialogContent className="phiModal" sx={{ pb: 0 }}>
          <h5>Redacted Certified Copy</h5>
          <p>Verify if the following information according to the document is correct:</p>

          <ul>
            <li>All pages of the document are present</li>
            <li>There are no blank pages present</li>
            <li>Pages are in the correct order</li>
            <li>All content in the margins is viewable</li>
            <li>All wet-ink signatures and dates are viewable</li>
            <li>The image/uploaded document is clear</li>
            <li>Document is in the final version</li>
            <li>All PHI has been redacted from this document </li>
          </ul>

          <FormGroup>
            <FormControlLabel
              sx={{ pl: 2.5 }}
              control={<Checkbox checked={certified} onChange={handleChangeCheck} />}
              label="I have verified the following information above"
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} className="grey-btn">
            Close
          </Button>
          <Button onClick={handleSave} disabled={certified === false}>
            Save
          </Button>
        </DialogActions>
      </React.Fragment>
    </div>
  );
};
